import { render, staticRenderFns } from "./StockCaja.vue?vue&type=template&id=21c86858&"
import script from "./StockCaja.vue?vue&type=script&lang=js&"
export * from "./StockCaja.vue?vue&type=script&lang=js&"
import style0 from "./StockCaja.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports